import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

function MediaQueryMd(props) {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.only('md'));
  if(matches) {
    return props.content
  } else {
    return null
  }
}

export default MediaQueryMd;